<template>
   <div>
       <div class="row">
           <div class="col-md-6">
                <h2>
                    {{ affiliateName }} / {{ advertisement.advertise_size.size_name }} 
                </h2>
            </div>
            <div class="col-md-6 form mt-5">
                <div class="row">
                    <div class="col-md-3">
                        <label for="addword_sent"> Mark as Paid ? </label>
                        <label class="switch">
                            <input id="addword_paid" type="checkbox" v-model="artworkInvoicePaid" @change="updateArtworkStatus()">
                            <span class="switch__slider"></span>
                        </label>  
                    </div>
                    <div class="col-md-3">
                        <label for="addword_sent"> Mark as Created ? </label>
                        <label class="switch">
                            <input id="addword_paid" type="checkbox" v-model="artworkCreated" @change="updateArtworkStatus()">
                            <span class="switch__slider"></span>
                        </label>  
                    </div>
                    <div class="col-md-3">
                        <label for="addword_sent"> Mark as Sent ? </label>
                        <label class="switch">
                            <input id="addword_paid" type="checkbox" v-model="artworkSent" @change="updateArtworkStatus()">
                            <span class="switch__slider"></span>
                        </label>  
                    </div>
                </div>
            </div>
       </div>
       <hr/>
       <div class="row">
        <div class="col-md-12">
            <h5 style="line-height: 30px" class="color-orange">
                Total : {{ InvoiceAmount | formatCurrency }} <br>
                Paid  : {{ totalPaidAmount | formatCurrency }} <br>
                Left  : {{ totalLeftAmount | formatCurrency }}<br>
            </h5>
        </div>
       </div>
       <hr/>
        <div class="box__header">
            <form class="form" v-on:submit.prevent="recordProductPayment">
                <div class="row">
                    <div class="col-md-4">
                        <label for="filter_by_tour"> Select tour </label>
                        <v-select
                            v-if="tours !== null"
                            v-model="advertiseInvoice.tour_id"
                            label="name"
                            class="v-select--medium"
                            :options="tours"
                            index="id"
                            placeholder="Filter by tour"
                            
                            >
                            <template #search="{attributes, events}">
                                <input
                                class="vs__search"
                                :required="!selectedTour"
                                v-bind="attributes"
                                v-on="events"
                                />
                            </template>
                            </v-select>
                    </div>
                    <div class="col-md-4">
                        <label for="filter_by_tour"> Size </label>
                        <select v-model="advertiseInvoice.size_id">
                            <option value="">Select Size</option>
                            <option v-for="sizes in advertiseSizes" :value="sizes.size_id" :key="sizes.size_name">{{ sizes.size_name }}</option>
                        </select>
                    </div>
                    <div class="col-md-4">
                        <div>
                            <label for="d-from-date">AddWord Cost</label>
                            <input id="" step="0.01" type="number" placeholder="AddWord Cost" v-model="advertiseInvoice.amount"/>
                        </div>
                    </div>
                </div>
                <div class="row mt-3">
                    <div class="col-md-4">
                        <div class="form-submit-inline">
                            <button type="submit" class="button">
                                <span> {{(advertiseInvoice.flag == 'add' ) ? 'Add' : 'Edit' }} Product </span>
                            </button>
                        </div>
                    </div>
                </div>
            </form>
        </div>
        <hr/>
        <div class="row">
            <div class="col-md-12">
                <table class="table" cellspacing="0">
                    <thead>
                        <tr>
                            <th>Tour</th>
                            <th>Size</th>
                            <th>Cost</th>
                            <th></th>
                            <th></th>
                        </tr>
                    </thead>
                    <tbody>
                        <template v-if="products.length > 0 ">
                            <tr v-for="product in products" :key="product.id">
                                <td>{{ product.tour.name }}</td>
                                <td>{{ product.size.size_name }}</td>
                                <td>{{ Number(product.amount) | formatCurrency }}</td>
                                <td class="table-action"><a v-on:click="editProductPayment(product.id)"  class="button p-2">Edit</a></td>
                                <td class="table-action"><a v-on:click="deleteProductPayment(product.id)" class="button p-2">Delete</a></td>
                            </tr>
                        </template>
                        <template v-else>
                            <tr>
                                <td colspan="5" class="text-center"> 
                                <h4>No data available.</h4>
                                </td>
                            </tr>
                        </template>
                    </tbody>
                </table>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'AdvertisementInvoices',
    props: {
        advertiseSizes: Array,
        products: Array,
        advertisement: Object,
        affiliateName:String,
        affiliateID:Number,
    },
    data() {
        return {
            selectedTour: null,
            advertiseInvoice: {
                flag: 'add',
                advertisement_id:this.advertisement.advertisement_id
            },
            tours:[]
        }
    },
    created: function () {
        this.getTours()
    },
    computed: {
        InvoiceAmount() {
            return (this.advertisement.invoice_amount) ? this.advertisement.invoice_amount : this.advertisement.total_cost
        },
        totalPaidAmount() {
            let paidAmount = 0
            if (this.products.length > 0 ) {
                this.products.forEach(element => {
                    paidAmount+=Number(element.amount)
                });
            }

            return paidAmount;
        },
        totalLeftAmount() {
            return Number(this.InvoiceAmount) - this.totalPaidAmount
        },
        artworkCreated : {
            get: function() {
                return this.advertisement.is_graphic_created;
            },
            set: function (newValue) {
                this.advertisement.is_graphic_created = newValue
            }
        },
        artworkSent: {
            get: function() {
                return this.advertisement.is_sent;
            },
            set: function (newValue) {
                this.advertisement.is_sent = newValue
            }
        },
        artworkInvoicePaid: {
            get: function() {
                return this.advertisement.paid_status;
            },
            set: function (newValue) {
                this.advertisement.paid_status = newValue
            }
        },
    },
    methods: {
        uploadDoc(event) {
            this.advertiseInvoice.artwork_invoice = event.target.files[0];
        },
        getTours() {
            this.$store.dispatch('setLoadStatus')
            fetch(this.$api + 'tours', {
                headers: {
                    'Accept': 'application/json',
                    'Authorization': localStorage.getItem('token')
                }
            })
                .then(res => res.json())
                .then(response => {
                    this.tours = response.data
                    this.$store.dispatch('setLoadStatus')
                })
        },
        recordProductPayment() {
            let self = this

            self.$store.dispatch('setLoadStatus')
  
            fetch(`${self.$api}affiliates/advertisement-products/${self.affiliateID}/submit`, {
                method: 'POST',
                body: JSON.stringify(self.advertiseInvoice),
                headers:{
                    'Content-Type': 'application/json',
                    'Accept': 'application/json',
                    'Authorization': localStorage.getItem('token')
                }
            })
            .then(res => res.json())
            .then(response => {
                self.errors = response.errors
                if(response.status) {
                    self.$notify({
                        type: 'success',
                        title: response.message
                    });
                    self.advertiseInvoice = {
                        flag: 'add',
                        advertisement_id:self.advertisement.advertisement_id
                    }

                    self.$emit('syncProducts', response.advertisements_prodcuts)
                    
                } else if (response.errors) {
                    self.$notify({
                        type: 'error',
                        title: response.message
                    });
                }
                self.$store.dispatch('setLoadStatus')
            });
        },
        editProductPayment(product_id) {
            let foundProduct = this.products.find(element => element.id === product_id)
            if (foundProduct) {
                this.advertiseInvoice = {
                    flag: 'edit',
                    advertisement_invoice_id : product_id,
                    advertisement_id:this.advertisement.advertisement_id,
                    tour_id : foundProduct.tour_id,
                    size_id : foundProduct.size_id,
                    amount : foundProduct.amount,
                }
            }
        },
        deleteProductPayment(product_id) {
            this.$dialog
            .confirm(`Are you sure you want to delete this product ?`)
            .then(() => {
                this.$store.dispatch('setLoadStatus')
                fetch(`${this.$api}affiliates/advertisement-products/${this.advertisement.advertisement_id}/delete`, {
                    method: 'POST',
                    body: JSON.stringify({
                        'advertisement_invoice_id' : product_id,
                    }),
                    headers: {
                        'Content-Type': 'application/json',
                        'Accept': 'application/json',
                        'Authorization': localStorage.getItem('token')
                    }
                })
                .then(res => res.json())
                .then(response => {
                    this.errors = response.errors
                    if(response.status) {
                        this.$notify({
                            type: 'success',
                            title: response.message
                        });
                        this.$emit('syncProducts', response.advertisements_prodcuts)
                    } else if (response.errors) {
                        this.$notify({
                            type: 'error',
                            title: response.message
                        });
                    } else {
                        this.$notify({
                            type: 'error',
                            title: response.Error
                        });
                    }
                    this.$store.dispatch('setLoadStatus')
                });
            }).catch(() => {
                this.$store.dispatch('setLoadStatus')
                console.log('Clicked on cancel');
            });
        },
        updateArtworkStatus() {
            let params = {
                artwork_id: this.advertisement.advertisement_id,
                column_status:[
                    {
                        column : 'is_graphic_created',
                        status : this.artworkCreated
                    },
                    {
                        column : 'is_sent',
                        status : this.artworkSent
                    },
                    {
                        column : 'paid_status',
                        status : this.artworkInvoicePaid
                    }
                ]
            }

            this.$store.dispatch('setLoadStatus')
  
            fetch(`${this.$api}affiliates/advertisement/update-artwork-status`, {
                method: 'POST',
                body: JSON.stringify(params),
                headers:{
                    'Content-Type': 'application/json',
                    'Accept': 'application/json',
                    'Authorization': localStorage.getItem('token')
                }
            })
            .then(res => res.json())
            .then(response => {
                this.errors = response.errors
                if(response.status) {
                    this.$notify({
                        type: 'success',
                        title: response.message
                    });
                } else if (response.errors) {
                    this.$notify({
                        type: 'error',
                        title: response.message
                    });
                }
                this.$store.dispatch('setLoadStatus')
            });
        }
    }
}
</script>

<style lang="scss" scoped>

</style>